const AssetIssue = {

    // FIELDS
    "asset_issue": "Asset Issue",
    "asset_code": "Asset Code",
    "asset_detail": "Asset Detail",
    "asset": "Asset",
    "issue_type": "Issue Type",
    "description": "Description",
    "reported_by": "Reported By",
    "reported_date": "Reported Date",
    "status": "Status",
    "search": "Search",

    // PAGE HEADER
    "list_title": "Asset Issue",
    "filter_title": "Asset Issue Filter",
    "details_title": "Asset Issue Details",

    // TABLE HEADER
    "table_asset": "Asset",
    "table_issue_type": "Issue Type",
    "table_staff": "Staff",
    "table_asset_code": "Asset Code",
    "table_asset_detail": "Asset Detail",
    "table_reported_by": "Reported By",
    "table_reported_date": "Reported Date",
    "table_status": "Status",
    "table_block": "Block",
    "table_location": "Location",
    "table_sub_location": "Sub Location",
    "table_description": "Description",

    // ERROR
    "error_asset": "Select Asset",
    "error_issue_type": "Select Issue Type",
    "error_description": "Enter Description",
    "error_reported_by": "Select Reported By",
    "error_reported_date": "Select Reported Date",
    "error_status": "Select Status",

}

export default AssetIssue;

